import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    flex: 1 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .form__phone {
        margin-top: 16px;
        margin-bottom: 64px;
    }

    .form__phone > .form__phone__field {
        margin-bottom: 52px;

        & > h6 {
            margin-bottom: -20px;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        form {
            display: initial;
            height: initial;
        }
    }
`
